import { AppMenu } from "./app-menu";
import { AppModule } from "./app-module";
import { Application } from "./application";
import { Profile } from "./profile";
import { SystemField } from "./system-field";

export class ProfilePermission extends SystemField {
    
    object_name?:string;
    record_id?:string;
    profiles_id?:string;
    is_visible?:string;

    //Relationship
    profile?:Profile;
    application?:Application;
    app_menu?:AppMenu;
    app_module?:AppModule;
}
